import styled from 'styled-components'
import { COLORS } from 'theme'

export const PreviewWrapper = styled.div`
  width: 100%;
  height: calc(100vh - 320px);
  min-height: 420px;
  display: flex;
  flex-direction: column;
  border: 1px solid ${COLORS.GREY_T_85};
  border-radius: 4px;
  overflow: hidden;
  background-color: ${COLORS.GREY_T_95};
`

// Stacked pages on a grey backdrop — the same treatment the JD attachment
// preview uses, so an attachment looks the same wherever it appears.
export const ScrollArea = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`

export const PageImage = styled.img`
  max-width: 100%;
  height: auto;
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
`

export const FallbackCard = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 32px 24px;
  min-height: 240px;
  text-align: center;
  background-color: ${COLORS.GREY_T_95};
`

export const FallbackTitle = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: ${COLORS.GREY_T_30};
`

export const FallbackText = styled.p`
  margin: 0 0 8px;
  font-size: 14px;
  color: ${COLORS.GREY_T_60};
`

// Google's Drive and document viewers are frames, not files we draw ourselves.
export const PreviewFrame = styled.iframe`
  flex: 1;
  width: 100%;
  border: 0;
  background-color: ${COLORS.GREY_T_95};
`
